export default {
  'get-list': {
    method: 'post',
    url: '/driver/license/list/ID'
  },
  add: {
    method: 'post',
    url: '/driver/license'
  },
  delete: {
    method: 'delete',
    url: '/driver/license'
  },
  get: {
    method: 'get',
    url: '/driver/license/ID'
  },
  edit: {
    method: 'put',
    url: '/driver/license/ID'
  },
  archive: {
    method: 'delete',
    url: '/driver/license/archive'
  },
  restore: {
    method: 'put',
    url: '/driver/license/restore'
  }
}
